<template>
  <div class="container">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>报表库</h4>
        <span class="f-s-14 c-m-l-15"></span>
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入报表标题"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增报表</el-button>
      </div>
    </div>
    <div class="reports">
      <div class="filter">
        <div class="c-font-500">筛选</div>
        <div class="m-t-20">报表内容</div>
        <el-checkbox-group v-model="contentType" class="filter-checkbox" @change="getData">
          <el-checkbox v-for="(item, i) in options.contentType" :key="i" :label="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="m-t-20">报表类型</div>
        <el-checkbox-group v-model="reportType" class="filter-checkbox" @change="getData">
          <el-checkbox v-for="(item, i) in options.reportType" :key="i" :label="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="c-flex-1 c-flex c-flex-col">
        <div class="c-flex c-flex-between" style="padding: 0 30px">
          <span>查询到{{ fpi.total || 0 }}个报表</span>
          <el-switch
            v-model="notAdded"
            active-text="仅展示未加入看板的报表"
            @change="getData"
          ></el-switch>
        </div>
        <div class="c-flex-1" style="overflow-y: auto; padding-bottom: 300px">
          <grid-layout
            :layout.sync="layout"
            :col-num="2"
            :row-height="500"
            :is-draggable="false"
            :is-resizable="false"
            :static="true"
            :is-mirrored="false"
            :vertical-compact="true"
            :margin="[20, 20]"
            :use-css-transforms="true"
            :responsive="false"
            :cols="{ lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 }"
            @layout-updated="renderCharts(layout)"
          >
            <grid-item
              v-for="item in layout"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              :key="item.i"
            >
              <div class="report c-flex c-flex-col" style="box-sizing: border-box; height: 100%">
                <div class="report-info">
                  <h3 class="c-m-b-20">{{ item.report.title }}</h3>
                  <el-button
                    plain
                    round
                    type="primary"
                    size="small"
                    @click="
                      add.formData = $util.deepCopy(item);
                      add.show = true;
                    "
                  >
                    添加到看板
                  </el-button>
                  <el-button
                    plain
                    round
                    type="danger"
                    size="small"
                    @click="removeFrom(item.report)"
                    v-if="false && addedReports.indexOf(item.report._id) != -1"
                  >
                    从所有看板移除
                  </el-button>
                  <!-- v-if="tenantId == '0'" -->
                  <template v-if="osg.has('Reports,operation')">
                    <el-button plain round type="primary" size="small" @click="doEdit(item.report)">
                      编辑
                    </el-button>
                    <el-button
                      round
                      type="danger"
                      size="small"
                      @click="doEnable(item.report._id)"
                      v-if="item.report.state == 0"
                    >
                      已禁用
                    </el-button>
                    <el-button
                      round
                      type="success"
                      size="small"
                      @click="doDisable(item.report._id)"
                      v-else
                    >
                      已启用
                    </el-button>
                    <el-button
                      plain
                      round
                      type="danger"
                      size="small"
                      @click="doRemove(item.report)"
                    >
                      删除
                    </el-button>
                  </template>
                  <div class="report-question">{{ item.report.question }}</div>
                  <div class="c_size_14">
                    {{ item.report.description }}
                  </div>
                </div>
                <div
                  class="flex-1"
                  :id="item.report._id"
                  :ref="item.report._id"
                  style="width: 100%; height: 100%"
                >
                  <div v-html="item.report.html" class="report-html" v-if="item.report.html"></div>
                  <cReportLit
                    :reportData="item.report"
                    v-if="item.report.reportType == 'table'"
                  ></cReportLit>
                </div>
              </div>
            </grid-item>
          </grid-layout>
        </div>
      </div>
    </div>
    <el-dialog title="报表" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="70px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="问题" prop="question">
          <el-input v-model="formData.question"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item label="报表内容">
          <el-select v-model="formData.contentType" multiple>
            <el-option
              v-for="item in options.contentType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表类型">
          <el-select v-model="formData.reportType">
            <el-option
              v-for="item in options.reportType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-select v-model="formData.filterCondition.date.type" @change="$forceUpdate()">
            <el-option
              v-for="item in options.dateRangeType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.filterCondition.date.type == 'custom'">
          <el-date-picker
            v-model="formData.filterCondition.date.range"
            @blur="$forceUpdate()"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="HTML">
          <el-input v-model="formData.htmlPart" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="JS">
          <el-input v-model="formData.jsPart" type="textarea" :rows="20"></el-input>
        </el-form-item>
        <el-form-item label="报表配置">
          <el-input v-model="formData.config" type="textarea" f :rows="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加到看板" :visible.sync="add.show">
      <el-form
        :model="add.formData"
        :rules="rules"
        ref="addformData"
        label-width="70px"
        label-position="top"
        hide-required-asterisk
      >
        <el-form-item label="将此报表添加到哪个看板？">
          <el-select v-model="add.dashboard">
            <el-option
              v-for="item in options.dashboard"
              :key="item.value"
              :label="item.label"
              :value="item"
              :disabled="item.addedReports.indexOf(add.show && add.formData.report._id) != -1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="addTo">确 定</el-button>
        <el-button
          @click="
            add.show = false;
            add.formData = {};
            add.dashboard = {};
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueGridLayout from 'vue-grid-layout';
import cReportLit from '../../components/reportList.vue';

let echarts = require('echarts');
export default {
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    cReportLit
  },
  data() {
    window.$this = this;
    let that = this;
    return {
      chart: echarts,
      tenantId: '',
      layout: [],
      openDetail: false,
      formData: { filterCondition: { date: { range: [] } } },
      rules: that.$util.rules,
      fpi: {},
      searchValue: '',
      globalDate: [], //全局时间筛选
      options: {
        codecfg_reportType: { codeId: 'reportType' },
        codecfg_contentType: { codeId: 'contentType' },
        codecfg_dateRangeType: { codeId: 'DATERANGETYPE' }
      },
      addedReports: [], //所有已添到看板的报表
      notAdded: false, //筛选 是否仅展示未添加的报表
      contentType: [], //筛选 报表内容
      reportType: [], //筛选 报表展示类型
      //将此报表添加到指定看板
      add: {
        formData: {},
        dashboard: {},
        show: false
      },
      //从所有看板移除此报表
      remove: {
        formData: {},
        show: false
      },
      //当前页面各报表块数据
      reports: {}
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.osg.codeoption(() => {
      this.$forceUpdate();
      this.getDashboard();
    });
  },
  methods: {
    doInit() {
      this.openDetail = false;
      this.formData = {
        filterCondition: { date: { range: [] } }
      };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        _all: '1',
        'regex:title|string#and': this.searchValue, //标题搜索
        'in:contentType|array#and': this.contentType.toString(), //报表内容筛选
        'in:reportType|array#and': this.reportType.toString() //报表类型筛选
      };
      //平台管理员admin可查看启用和禁用,租户只查看已启用
      if (this.tenantId == '0') {
        params['in:state|array-integer#and'] = '0,1';
      } else {
        params['is:state|integer#and'] = 1;
      }
      //仅展示未添加到看板的报表
      if (this.notAdded) {
        params['nin:_id|string#and'] = this.addedReports;
      }
      this.osg.ajax(
        'biz/report/query.do',
        params,
        res => {
          let layout = [];
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            let obj = {
              x: i % 2,
              y: Math.floor(i / 2),
              w: 1,
              h: 1,
              i: item._id,
              report: item
            };
            layout.push(obj);
          }
          this.layout = layout;
          this.fpi = res;
          this.renderCharts(layout);
        },
        { noload: true }
      );
    },
    //渲染报表块的图表
    renderCharts(layout) {
      this.$nextTick(() => {
        for (let item of layout) {
          if (item.report.jsPart) {
            try {
              eval(item.report.jsPart);
            } catch (e) {
              console.log('报错看板：' + item.report.title);
              console.log('报错内容：' + e.toString());
              console.log('报错看板对象：', item.report);
              console.log('-------------------');
            }
          }
        }
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doEdit(item) {
      this.formData = this.$util.deepCopy(item);
      //filterCondition赋值防止报错
      this.formData.filterCondition = this.formData.filterCondition || {};
      this.formData.filterCondition.date = this.formData.filterCondition.date || {};
      this.formData.filterCondition.date.range = this.formData.filterCondition.date.range || [];
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.osg.ajax(
          'biz/report/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功');
          },
          { noload: true }
        );
      }
    },
    //平台管理员功能 启用、禁用、删除
    doEnable(id) {
      this.osg.ajax(`biz/report/enable/${id}.do`, null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`biz/report/disable/${id}.do`, null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(item) {
      this.osg.confirm(`是否从报表库删除报表"${item.title}"？`, () => {
        this.osg.ajax(`biz/report/remove/${item._id}.do`, null, res => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //租户功能 将此报表添加到指定看板
    addTo() {
      let dashboard = this.$util.deepCopy(this.add.dashboard);
      let reports = dashboard.reports || [];
      let maxY = 0;
      for (let item of reports) {
        if (item.report.y > maxY) maxY = item.report.y;
      }
      let obj = {
        x: 0,
        y: maxY + 1,
        w: 1,
        h: 1,
        i: this.add.formData.report._id,
        report: this.add.formData.report
      };
      dashboard.reports.push(obj); //将添加到看板的报表id插入addedReports
      //编辑平台预置看板 新增看板
      if (dashboard.tenantId == '0' && this.tenantId != '0') {
        dashboard.tenantId = this.tenantId;
        dashboard.sourceId = dashboard._id;
        dashboard._id = '';
      }
      this.osg.ajax(
        'biz/dashboard/upsert.do',
        { dashboard: JSON.stringify(dashboard) },
        () => {
          //将当前报表id插入到整体addedReports
          this.addedReports.push(this.add.formData.report._id);
          //将当前报表id插入到添加到的看板的addedReports
          for (let item of this.options.dashboard) {
            if (dashboard._id == item._id) {
              item.addedReports.push(this.add.formData.report._id);
              break;
            }
          }
          this.add = {
            formData: {},
            dashboard: {},
            show: false
          };
          this.getDashboard();
          this.osg.toast('已添加到看板');
        },
        { noload: true }
      );
    },
    //租户功能 将此报表从所有看板移除
    removeFrom(row) {
      this.osg.confirm(
        `是否从所有看板中删除报表"${row.title}"？该报表将保留在您的报表库中，并且可以随时添加回看板。`,
        () => {
          this.osg.ajax('', null, res => {
            this.osg.toast('删除成功');
          });
        }
      );
    },
    //获取所有可查看看板，收集已经加入看板的reportId
    getDashboard() {
      this.osg.ajax(
        'biz/dashboard/query.do',
        {
          'nin:exts.type|string#and': 2
        },
        res => {
          let addedReports = [];
          res.data.map(item => {
            item.label = item.boardName;
            item.value = item._id;
            item.reports = item.reports || [];
            item.addedReports = [];
            for (let report of item.reports) {
              item.addedReports.push(report.report._id);
              addedReports.push(report.report._id);
            }
          });
          this.addedReports = addedReports;
          this.options.dashboard = res.data;
          this.getData();
        },
        { noload: true }
      );
    }
  }
};
</script>
<style scoped>
.container {
  margin: -10px -20px;
  height: calc(100% + 20px);
  background: #f5f8fa;
  overflow: hidden;
}
.head-box {
  background: #fff;
  padding: 0 10px;
  border-top: 1px solid #dfe3eb;
}
.reports {
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  flex: 1;
}
.vue-grid-layout {
}
.vue-grid-item {
  border-radius: 3px;
  background-color: #fff;
  cursor: grab !important;
  transition: box-shadow 0.15s ease-in-out;
  overflow: hidden;
}
.vue-grid-item:hover {
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
}
.filter {
  padding: 0 20px;
}
.filter-checkbox > label {
  display: block;
  padding: 10px;
  margin-right: 0;
  flex-direction: row;
}
.report {
  padding: 20px;
}
.report-info {
  height: 200px;
  overflow: hidden;
}
.report-question {
  font-weight: 500;
  padding: 20px 0 10px;
}
.report-html {
  width: 100%;
  height: 100%;
}
</style>
